<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'aulas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Lançando Frequências
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="aula">
        <v-card color="green lighten-1" class="mb-5" outlined>
          <v-card-title> Professor: {{ aula.professor.nome }} </v-card-title>
          <v-card-subtitle class="font-weight-medium">
            <div>Turma: {{ aula.turma.descricao }}</div>
            <div>Disciplina: {{ aula.disciplina.descricao }}</div>
            <div>Data: {{ aula.data_formatada }}</div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="aula">
      <v-col cols="12" v-if="user && aula.data <= user.data_bloqueio">
        <v-alert border="left" elevation="3" type="error">
          O lançamento de frequência para a data <strong>{{ aula.data_formatada }}</strong> foi
          bloqueado. Por favor, entre em contato com o administrador.
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        v-if="!(user && aula.data <= user.data_bloqueio) && notifiqLancamentoEnabled"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="success"
              class="mb-4"
              :loading="importandoNotifiq"
              @click="getPresencasHikvision"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>mdi-bell-ring</v-icon>
              Usar Notifiq
            </v-btn>
          </template>
          <span>Importa automaticamente as presenças capturadas no dispositivo.</span>
        </v-tooltip>
      </v-col>
      <v-col v-if="!(user && aula.data <= user.data_bloqueio)" cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Aluno</th>
                <th class="text-left">Presença</th>
                <th class="text-left">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="presenca of presencas"
                :key="presenca.matricula_id"
                :class="
                  $constants.situacoesMatriculaCondition[
                    removerEspaco(presenca.matricula.situacao ? presenca.matricula.situacao : '')
                  ]
                    ? 'red lighten-4'
                    : null
                "
              >
                <td class="font-weight-medium">
                  <div>
                    {{
                      presenca.matricula.aluno
                        ? presenca.matricula.aluno.nomecompleto
                        : `[ALUNO POSSIVELMENTE DELETADO] MATRICULA: ${presenca.matricula.id}`
                    }}
                    <v-chip
                      label
                      color="error"
                      small
                      v-if="
                        $constants.situacoesMatriculaCondition[
                          removerEspaco(
                            presenca.matricula.situacao ? presenca.matricula.situacao : ''
                          )
                        ]
                      "
                      >{{ presenca.matricula.situacao }}</v-chip
                    >
                  </div>
                  <div>
                    <small>
                      {{
                        presenca.matricula.aluno ? presenca.matricula.aluno.codigo_inep : "- - -"
                      }}
                      /
                      {{ presenca.matricula.aluno ? presenca.matricula.aluno.codigo : "- - -" }}
                    </small>
                  </div>
                </td>
                <td>
                  <v-btn-toggle :value="presenca.presente ? 0 : 1" v-if="presenca.matricula.aluno">
                    <v-btn
                      v-if="
                        !$constants.situacoesMatriculaCondition[
                          removerEspaco(
                            presenca.matricula.situacao ? presenca.matricula.situacao : ''
                          )
                        ]
                      "
                      @click="atualizarFrequencia(presenca, true)"
                      :color="presenca.presente ? 'green' : 'grey lighten-2'"
                      small
                      ><v-icon x-small>fa fa-thumbs-up</v-icon></v-btn
                    >
                    <v-btn
                      v-if="
                        !$constants.situacoesMatriculaCondition[
                          removerEspaco(
                            presenca.matricula.situacao ? presenca.matricula.situacao : ''
                          )
                        ]
                      "
                      @click="atualizarFrequencia(presenca, false)"
                      :color="!presenca.presente ? 'red' : 'grey lighten-2'"
                      small
                      ><v-icon x-small>fa fa-thumbs-down</v-icon></v-btn
                    >
                  </v-btn-toggle>
                </td>
                <td>
                  <v-btn
                    v-if="!presenca.presente"
                    color="success"
                    @click="
                      modalFalta(presenca.matricula, presenca.justificativa_id, presenca.observacao)
                    "
                    small
                    type="button"
                  >
                    Observação
                  </v-btn>
                  <v-tooltip v-if="!presenca.presente && presenca.document" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        @click="documentoJustificativaFalta(presenca.matricula.id)"
                        class="ml-2"
                        color="red lighten-5"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="red lighten-1" small> fa fa-file-pdf</v-icon>
                      </v-btn>
                    </template>
                    <span>Baixar documento</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-snackbar
      dense
      :value="exibirSnackbar"
      :timeout="-1"
      class="mb-12"
      :color="snackbarColor"
      right
      bottom
    >
      <div v-if="promisesCount > 0" class="d-flex align-center">
        <v-progress-circular indeterminate size="25" color="white"></v-progress-circular>
        <span class="ml-2 font-weight-medium">Salvando dados de frequência no servidor</span>
        <v-btn @click="fecharSnackbar" class="ml-2" icon><v-icon small>fa fa-close</v-icon></v-btn>
      </div>
      <div v-else-if="errorMessages.length == 0" class="d-flex align-center">
        <v-icon size="20" color="white">fa fa-check</v-icon>
        <span class="ml-2 font-weight-medium">Dados de frequência salvos no servidor!</span>
        <v-btn @click="fecharSnackbar" class="ml-2" icon><v-icon small>fa fa-close</v-icon></v-btn>
      </div>
      <div v-else class="d-flex align-center">
        <v-icon size="20" color="white">fa fa-exclamation-circle</v-icon>
        <span class="ml-2 font-weight-medium">Erro ao salvar dados de frequência!</span>
        <v-btn @click="fecharSnackbar" class="ml-2" icon><v-icon small>fa fa-close</v-icon></v-btn>
      </div>
    </v-snackbar>
    <e-modal-dinamic>
      <ValidationObserver>
        <form :disabled="submittingForm">
          <e-autocomplete
            :items="justificativas"
            :return-object="false"
            :item-value="(value) => value.id"
            :item-text="(value) => value.descricao"
            v-model="form.justificativa_id"
            label="Selecione uma opção"
          />
          <!-- id 4 = OUTROS -->
          <template v-if="form.justificativa_id === 4">
            <v-text-field v-model="form.observacao" label="Obs.:" outlined />
          </template>
        </form>
      </ValidationObserver>
    </e-modal-dinamic>
  </main-template>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    aula_id: {
      type: [String, Number],
      required: true,
    },
  },
  mounted() {
    this.loadBasicData();
  },
  data() {
    return {
      submittingForm: false,
      aula: null,
      presencas: [],
      exibirSnackbar: false,
      promisesCount: 0,
      errorMessages: [],
      justificativas: [],
      form: {
        observacao: "",
        file: null,
        matriculaSelect: {},
        justificativa_id: 0,
      },
      matriculaSelect: {},
      notifiqLancamentoEnabled: false,
      importandoNotifiq: false,
    };
  },
  computed: {
    snackbarColor() {
      if (this.errorMessages.length > 0) return "error";
      return this.promisesCount > 0 ? "info" : "success";
    },
    ...mapGetters("Auth", ["user"]),
    data_bloqueado() {
      return this.adicionarUmDia(this.user?.data_bloqueio);
    },
  },
  methods: {
    getHorarioIdsDaAula() {
      if (!this.aula) return [];

      const ids = [
        this.aula.horario_id,
        this.aula.horario && this.aula.horario.id,
        ...(Array.isArray(this.aula.horarios) ? this.aula.horarios : []),
        ...(Array.isArray(this.aula.horarios_com_descricao)
          ? this.aula.horarios_com_descricao.map((horario) => horario && horario.id)
          : []),
      ]
        .map((value) => parseInt(value, 10))
        .filter((value) => Number.isInteger(value) && value > 0);

      return [...new Set(ids)];
    },
    async loadBasicData() {
      this.$loaderService.open("Carregando dados...");
      try {
        const [response, aula, notifiqLancamentoStatus] = await Promise.all([
          this.$services.aulasService.justificativas(),
          this.$services.aulasService.getAulaComRelacoes(this.aula_id),
          this.$services.appConfigurationService
            .getNotifiqLancamentoStatus()
            .catch(() => ({ enabled: false })),
        ]);

        this.justificativas = response.justificativas;
        this.aula = aula;
        this.notifiqLancamentoEnabled = !!notifiqLancamentoStatus?.enabled;
        this.form.file = null;
        this.presencas = aula.turma.matriculas.map((matricula) => {
          const faltou =
            this.aula.faltas.filter(
              (falta) => parseInt(falta.matricula_id, 10) === parseInt(matricula.id, 10)
            ).length > 0;
          const falta = this.aula.faltas.filter(
            (falta) => parseInt(falta.matricula_id, 10) === parseInt(matricula.id, 10)
          );
          return {
            matricula,
            matricula_id: matricula.id,
            presente: !faltou,
            document: falta[0] ? falta[0].document : null,
            justificativa_id: falta[0] ? falta[0].justificativa_id : null,
            observacao: falta[0] ? falta[0].observacao : null,
          };
        });
      } finally {
        this.$loaderService.close();
      }
    },
    async atualizarFrequencia(frequencia, novoEstado) {
      // se tiver colocando presente reseta a justificativa e a observação
      if (novoEstado) {
        frequencia.justificativa_id = null;
        frequencia.observacao = null;
      }
      frequencia.presente = novoEstado;
      this.exibirSnackbar = true;
      this.promisesCount += 1;
      try {
        await this.$services.aulasService.registrarPresenca(this.aula, frequencia);
      } catch (error) {
        this.errorMessages.push(error.message);
        this.$handleError(error);
      }
      this.promisesCount -= 1;
    },
    async modalFalta(matricula, justificativa_id, observacao) {
      this.form.matriculaSelect = matricula;
      this.form.justificativa_id = parseInt(justificativa_id, 10);
      this.form.observacao = observacao || "";
      this.$modalsDinamic.info({
        title: "Justificar falta",
        label: `Observação`,
        fileinput: "Anexe um arquivo",
        visibleIcon: true,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modalsDinamic.close();
            },
            props: {
              color: "warning",
              small: true,
              text: true,
            },
          },
          {
            text: "Confirmar",
            callback: async () => {
              if (!this.form.justificativa_id) {
                this.$toast.danger("É necessário fornecer uma justificativa para a falta.");
                return;
              }
              try {
                await this.$services.aulasService.justificarFalta(this.aula, this.form);
                this.$modalsDinamic.setOptions({ loading: true });
                this.$modalsDinamic.close();
                this.$toast.success("Justificativa inserida com sucesso!");
                await this.loadBasicData();
              } catch (error) {
                this.$toast.danger("O campo file deve ser um arquivo do tipo: pdf.");
              }
            },
            props: {
              color: "success",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    fecharSnackbar() {
      this.exibirSnackbar = false;
      this.errorMessages = [];
    },
    removerEspaco(string) {
      return string.replace(" ", "_").replace(" ", "_").replace(" ", "_");
    },
    async documentoJustificativaFalta(matricula_id) {
      this.$loaderService.open("Baixando...");
      try {
        await this.$services.relatoriosService.documentoJustificativaFalta(
          parseInt(this.aula.id, 10),
          parseInt(matricula_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async getPresencasHikvision() {
      if (!this.aula) return;

      const date = this.aula.data || this.aula.data_formatada || null;
      const horarioIds = this.getHorarioIdsDaAula();
      const turma_id = this.aula.turma && this.aula.turma.id ? this.aula.turma.id : null;

      if (!date || !horarioIds.length || !turma_id) {
        this.$toast.danger(
          "Dados insuficientes para buscar presenças do Hikvision (data/horário/turma)."
        );
        return;
      }

      this.importandoNotifiq = true;
      this.$loaderService.open("Buscando presenças capturadas no Hikvision...");

      try {
        const data = await this.$services.presencasService.getPresencasNotifiqHikvision({
          date,
          horario_ids: horarioIds,
          turma_id,
        });

        const candidates = data.candidates || [];

        if (!candidates.length) {
          this.$toast.info("Nenhum registro de presença encontrado no Notifiq para esse horário.");
          return;
        }

        const atualizacoes = candidates
          .map((cand) => {
            const idx = this.presencas.findIndex(
              (p) => parseInt(p.matricula_id, 10) === parseInt(cand.matricula_id, 10)
            );

            if (idx === -1) return null;

            const presencaAtual = this.presencas[idx];
            const estadoAnterior = presencaAtual.presente;
            let marcarPresente = estadoAnterior;

            if (cand.status === "present") {
              marcarPresente = true;
            } else if (cand.status === "no_event") {
              marcarPresente = false;
            }

            this.$set(this.presencas, idx, {
              ...presencaAtual,
              presente: marcarPresente,
              origem: "hikvision",
              logsHikvision: cand.presencas || [],
            });

            if (estadoAnterior === marcarPresente) return null;

            return this.atualizarFrequencia(this.presencas[idx], marcarPresente);
          })
          .filter(Boolean);

        const applied = atualizacoes.length;

        await Promise.all(atualizacoes);

        if (applied > 0) {
          this.$toast.success("Presenças aplicadas automaticamente pelo Notifiq.");
        } else {
          this.$toast.info("Nenhuma presença/falta foi alterada automaticamente.");
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.importandoNotifiq = false;
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style scoped></style>
